module.exports = __webpack_public_path__ + "img/login_view2.d6ee5bc6.jpeg";